import http from 'utils/http';
import { getLlmServicesUrl, getServicesUrl, getSttServicesUrl, getTtsServicesUrl } from './apiUrls';
import { ServicesResponse } from './types';

export function getServices(): Promise<{ data: ServicesResponse }> {
  return http.get(getServicesUrl());
}

export function getTtsServices(): Promise<{ data: string[] }> {
  return http.get(getTtsServicesUrl());
}

export function getSttServices(): Promise<{ data: string[] }> {
  return http.get(getSttServicesUrl());
}

export function getLlmServices(): Promise<{ data: string[] }> {
  return http.get(getLlmServicesUrl());
}
